import { Tooltip } from "antd";

import active from "data/icons/check-green.svg";
import expired from "data/icons/expired.svg";
import pending from "data/icons/pending.svg";

interface IStatusItem {
	is_active: boolean;
	is_pending: boolean;
	withLabel?: boolean;
}

const StatusItem = ({ is_active, is_pending, withLabel }: IStatusItem) => {
	return (
		<>
			{is_active && (
				<Tooltip title="Active">
					<img alt="" src={ active } />
				</Tooltip>
			)}

			{is_pending && (
				<Tooltip title="Pending">
					<img alt="" src={ pending } />
				</Tooltip>
			)}

			{!is_active && !is_pending && (
				<Tooltip title="Expired">
					<img alt="" src={ expired } />
				</Tooltip>
			)}

			{withLabel && (
				<>
					{is_active && "Active"}

					{is_pending && "Pending"}

					{!is_active && !is_pending && "Expired"}
				</>
			)}
		</>
	);
};

export default StatusItem;
